<h1 [class.sidebar]="sidebar">
  <i class="icon-{{ icon }}"></i>
  {{ text }}
</h1>
<ng-content></ng-content>
